<script lang="ts">
    export let label:string;
    export let value:any;
    export let name:string;
    export let role:inputRole = 'default';
    export let placeholder:string = '';
    export let maxChars:number = 32;
    export let warning:string = '';

    type inputRole = 'default' | 'family-name';

    import { createEventDispatcher } from 'svelte';
    import Icons from './icons.svelte';

    if (value === undefined) {
        value = '';
    }

    let className = '';
    if (role === 'family-name') {
        className = 'title';
    }

    const dispatch = createEventDispatcher();
    function inputChange() {
		dispatch('message', {
			text: 'Hello!'
		});
    }
</script>

<div class={className}>
    <label for={name}>{label}</label>
    <input name={name} bind:value={value} on:input={inputChange} placeholder={placeholder} maxlength={maxChars} />    
    {#if warning !== ''}
        <div class="message-area">
            <Icons icon={'alert'} color="alert"/>
            <p class="fine-print">{warning}</p>
        </div>
    {/if}

</div>

<style>
    label {
        font-size: 12px;
    }
    p.fine-print {
        margin-top: 0;
        display: inline-block;
    }
    .title > label {
        display: none;
    }
    .title > input {
        height: 3rem;
    }

    div:not(.title) {
        /* width: 30%; */
        margin-bottom: 0.5rem;
    }
    input {
        color: var(--text);
        border: none;
        padding: 0.4rem 0;
        width: 100%;
        background: var(--background);
    }
    .title > input {
        font-size: larger;
        font-weight: bold;
        margin: 0;
    }
    .message-area {
        display: flex;
    }
    .message-area > :global(svg) {
        flex: 16px 0 0;
        margin-right: 8px;
    }
</style>